import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';

/* eslint-disable @wordpress/no-global-event-listener */
export class EdModal {
	/*
	 * Init the handler
	 *
	 * @param    {HTMLElment} rootEl       The root element of the filter
	 */
	constructor(rootEl) {
		this.rootEl = rootEl;
		this.modalBtns = rootEl.querySelectorAll('.ed-modal');
		this.modalCloseBtns = rootEl.querySelectorAll('.ed-modal__close');
		this.modalOverlays = rootEl.querySelectorAll('.ed-modal__background');
		this.activeClass = 'active-modal';
		this.controlClass = 'ed-modal-open';

		const self = this;
		this.modalBtns.forEach((btn) => {
			btn.addEventListener('click', function () {
				self.openModal(this);
			});
		});

		this.modalCloseBtns.forEach((btn) => {
			btn.addEventListener('click', function () {
				self.closeModal();
			});
		});

		this.modalOverlays.forEach((btn) => {
			btn.addEventListener('click', function () {
				self.closeModal();
			});
		});
	}

	/*
	 * Open content modal
	 *
	 * @return    {void}
	 */
	openModal(btn) {
		btn.parentElement.classList.add(this.activeClass);
		this.toggleBodyOverflow();
	}

	/*
	 * Close content modal
	 *
	 * @return    {void}
	 */
	closeModal() {
		this.modalBtns.forEach((btn) => {
			btn.parentElement.classList.remove(this.activeClass);
		});
		this.toggleBodyOverflow();
	}

	/*
	 * Removes overflow from body when modal is open
	 *
	 * @return    {void}
	 */
	toggleBodyOverflow() {
		const alreadyOpen = document.body.classList.contains(this.controlClass);
		// Add the body class
		if (!alreadyOpen) {
			document.body.classList.add(this.controlClass);
		} else {
			document.body.classList.remove(this.controlClass);
		}
	}
}
